import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const StaffRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  if (!token || !userStr) {
    return <Navigate to="/login" />;
  }

  try {
    // Verify token is valid
    jwtDecode(token);
    
    // Check user role from stored user data
    const user = JSON.parse(userStr);
    if (!user || user.role !== 'STAFF') {
      return <Navigate to="/my-orders" />;
    }
    
    return children;
  } catch (error) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/login" />;
  }
};

export default StaffRoute;
